var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "mb5" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              staticClass: "searchContainer",
              attrs: {
                model: _vm.queryForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "basicData.TheNameOfTheQuoteProposal"
                            ),
                            prop: "name",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("orderDetails.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.params.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm.params, "name", $$v)
                              },
                              expression: "queryForm.params.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("collectionCenter.businessT"),
                            prop: "businessType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                              },
                              on: { change: _vm.businessTypeChange },
                              model: {
                                value: _vm.queryForm.params.businessType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "businessType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.businessType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "0",
                                attrs: {
                                  label: _vm.$t("collectionCenter.tudo"),
                                  value: null,
                                },
                              }),
                              _vm._l(_vm.PAYABLE_TYPE, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("basicData.UsageStatus"),
                            prop: "offerPriceStatus",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("basicData.pleaseChoose"),
                              },
                              model: {
                                value: _vm.queryForm.params.offerPriceStatus,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "offerPriceStatus",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.offerPriceStatus",
                              },
                            },
                            [
                              _c("el-option", {
                                key: 5,
                                attrs: {
                                  label: _vm.$t("basicData.all"),
                                  value: null,
                                },
                              }),
                              _vm._l(_vm.STATUS, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _vm.queryForm.params.businessType === 5
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.PayablePrincipal"),
                                prop: "payableEntityId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: _vm.$t(
                                      "basicData.PleaseSelect"
                                    ),
                                  },
                                  model: {
                                    value: _vm.queryForm.params.payableEntityId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "payableEntityId",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.payableEntityId",
                                  },
                                },
                                _vm._l(
                                  _vm.transportationProviderList,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          item.providerName +
                                          "(" +
                                          item.code +
                                          ")",
                                        value: item.id,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.PayablePrincipal"),
                                prop: "payableEntityId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    clearable: "",
                                    placeholder: _vm.$t(
                                      "spareNumberPoo.Only10AreDisplayed"
                                    ),
                                    remote: "",
                                    "remote-method": _vm.getProviderList,
                                  },
                                  on: { change: _vm.providerInfoChange },
                                  model: {
                                    value: _vm.queryForm.params.payableEntityId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.queryForm.params,
                                        "payableEntityId",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "queryForm.params.payableEntityId",
                                  },
                                },
                                _vm._l(_vm.providerData, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label:
                                        item.providerBody +
                                        "（" +
                                        item.providerName +
                                        "）(" +
                                        item.code +
                                        ")",
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _vm.queryForm.params.businessType !== 5
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("basicData.Outlets"),
                                prop: "siteIds",
                              },
                            },
                            [
                              _c("QuerySiteCmp", {
                                attrs: {
                                  val: _vm.queryForm.params.siteIds,
                                  "provider-id":
                                    _vm.queryForm.params.payableEntityId,
                                  multiple: true,
                                },
                                on: {
                                  change: function (val) {
                                    return (_vm.queryForm.params.siteIds = val)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("placeOrder.cargoType") } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                clearable: "",
                                placeholder: _vm.$t("basicData.PleaseSelect"),
                              },
                              model: {
                                value: _vm.queryForm.params.cargoType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "cargoType",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.cargoType ",
                              },
                            },
                            _vm._l(_vm.CARGO_TYPE, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "left" } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticStyle: { "margin-top": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-search",
                          size: "small",
                        },
                        on: { click: _vm.getDataSearch },
                      },
                      [_vm._v(_vm._s(_vm.$t("basicData.Search")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh", size: "small" },
                        on: { click: _vm.queryFormReset },
                      },
                      [_vm._v(_vm._s(_vm.$t("basicData.reset")) + " ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "div",
            { staticClass: "mb10 feet-r" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:payable:quoteManagement:addEdit",
                      expression: "'btn:payable:quoteManagement:addEdit'",
                      arg: "remove",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-plus",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handlerOperation(1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.Add")) + " ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permit",
                      rawName: "v-permit:remove",
                      value: "btn:payable:quoteManagement:export",
                      expression: "'btn:payable:quoteManagement:export'",
                      arg: "remove",
                    },
                  ],
                  staticClass: "feet-btn",
                  attrs: { size: "small", icon: "el-icon-download" },
                  on: { click: _vm.onExportData },
                },
                [_vm._v(_vm._s(_vm.$t("CenterForSorting.export")) + " ")]
              ),
              _c("BatchAdd", { on: { updatePage: _vm.updatePage } }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              ref: "elTable",
              staticClass: "table-height",
              attrs: {
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
                "current-row-key": "id",
                height: _vm.tableHeightRow.height,
              },
              on: { "sort-change": _vm.tableSortChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.serialNumber"),
                  width: "60px",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: _vm.$t("basicData.TheNameOfTheQuoteProposal"),
                  width: "180",
                  align: "left",
                  sortable: "custom",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-end",
                              "popper-class": "copy",
                              trigger: "hover",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  color: "black",
                                  "font-size": "12px",
                                },
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(scope.row.name)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("orderDetails.copy")) +
                                    " "
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "WaybillNumber",
                                attrs: { slot: "reference" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlerOperation(2, scope.row)
                                  },
                                },
                                slot: "reference",
                              },
                              [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "partitionName",
                  label: _vm.$t("basicData.PartitionSchemeName"),
                  align: "left",
                  width: "180",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "WaybillNumber",
                            on: {
                              click: function ($event) {
                                return _vm.handlerOperation(3, scope.row)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(scope.row.partitionName) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "payableEntityName",
                  label: _vm.$t("basicData.PayablePrincipal"),
                  align: "center",
                  sortable: "custom",
                  "show-overflow-tooltip": true,
                  width: "160",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "siteName",
                  label: _vm.$t("basicData.Outlets"),
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "businessType",
                  label: _vm.$t("collectionCenter.businessT"),
                  align: "center",
                  width: "160",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.PAYABLE_TYPE[scope.row.businessType] &&
                                  _vm.PAYABLE_TYPE[scope.row.businessType]
                                    .label) ||
                                  ""
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "offerPriceStatus",
                  label: _vm.$t("basicData.UsageStatus"),
                  align: "center",
                  width: "120",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                _vm.STATUS[scope.row.offerPriceStatus] &&
                                _vm.STATUS[scope.row.offerPriceStatus].type,
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                (_vm.STATUS[scope.row.offerPriceStatus] &&
                                  _vm.STATUS[scope.row.offerPriceStatus]
                                    .label) ||
                                  ""
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "cargoType ",
                  label: _vm.$t("placeOrder.cargoType"),
                  align: "center",
                  width: "160",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        [3, 4].includes(scope.row.businessType)
                          ? _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    (_vm.CARGO_TYPE[scope.row.cargoType] &&
                                      _vm.CARGO_TYPE[scope.row.cargoType]
                                        .label) ||
                                      ""
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "startOfValidityPeriod",
                  label: _vm.$t("basicData.TheValidityPeriodBegins"),
                  align: "center",
                  width: "160",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.startOfValidityPeriod.replace(
                                  "T",
                                  " "
                                )
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateUserStr",
                  label: _vm.$t("basicData.LastModifier"),
                  align: "center",
                  width: "120",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: _vm.$t("basicData.LastModified"),
                  align: "center",
                  width: "160",
                  "show-overflow-tooltip": true,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.operate"),
                  fixed: "right",
                  align: "center",
                  width: "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.applyType === true
                          ? _c(
                              "el-popconfirm",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:payable:quoteManagement:addEdit",
                                    expression:
                                      "'btn:payable:quoteManagement:addEdit'",
                                    arg: "remove",
                                  },
                                ],
                                attrs: {
                                  title: _vm.$t("basicData.AreYouSureDisabled"),
                                },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.asyncPartitionEdit(scope.row, 0)
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml",
                                    attrs: {
                                      slot: "reference",
                                      type: "danger",
                                      size: "mini",
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("basicData.disable")))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        scope.row.applyType === false
                          ? _c(
                              "el-popconfirm",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:payable:quoteManagement:addEdit",
                                    expression:
                                      "'btn:payable:quoteManagement:addEdit'",
                                    arg: "remove",
                                  },
                                ],
                                attrs: {
                                  title: _vm.$t("basicData.AreYouSureEnabled"),
                                },
                                on: {
                                  confirm: function ($event) {
                                    return _vm.asyncPartitionEdit(scope.row, 1)
                                  },
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "ml",
                                    attrs: {
                                      slot: "reference",
                                      type: "primary",
                                      size: "mini",
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v(_vm._s(_vm.$t("basicData.enable")))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "bottom-start",
                              trigger: "click",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "feet" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function () {
                                        return _vm.handlerOperation(
                                          4,
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("basicData.CopyAll")))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "feet-btn",
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function () {
                                        return _vm.handlerOperation(
                                          5,
                                          scope.row
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("basicData.PartialCopy"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:payable:quoteManagement:addEdit",
                                    expression:
                                      "'btn:payable:quoteManagement:addEdit'",
                                    arg: "remove",
                                  },
                                ],
                                staticClass: "ml",
                                attrs: {
                                  slot: "reference",
                                  type: "info",
                                  size: "mini",
                                },
                                slot: "reference",
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("orderDetails.copy"))),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.queryForm.pageNumber,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.queryForm.pageSize,
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentData,
                  "size-change": _vm.getSizeData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerObj.visible,
            "with-header": false,
            direction: "ltr",
            size: "90%",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.drawerObj, "visible", $event)
            },
          },
        },
        [
          _c("DetailsCmp", {
            key: _vm.editKey,
            attrs: {
              "edit-data": _vm.drawerObj.editData,
              "operation-type": _vm.drawerObj.typeIndex,
              "copy-model": _vm.drawerObj.copyModel,
            },
            on: { saveChange: _vm.updatePage },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.showPartitionDetail,
            "with-header": false,
            direction: "ltr",
            size: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showPartitionDetail = $event
            },
          },
        },
        [
          _c("PartitionDetails", {
            key: _vm.editKeyPartition,
            staticStyle: { height: "100%" },
            attrs: {
              "type-index": 3,
              "edit-data": _vm.drawerObj.editData,
              "all-state": _vm.payState,
              "all-city": _vm.allCity,
            },
            on: { updatePage: _vm.updatePage },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("orderDetails.copy"),
            visible: _vm.copyVisible,
            "append-to-body": "",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.copyVisible = $event
            },
          },
        },
        [
          _c("CopyLog", {
            on: { submit: _vm.submitCopy, close: _vm.cancelCopy },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }